export default __webpack_public_path__ + "static/title-suhack-847eae9f0beccb7f5a990d3385576bae.png";